"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../actions");
const campaigns_1 = require("../../actions/campaigns");
const reducers_1 = require("../../reducers");
const recharts_1 = require("recharts");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const GraphSelector_1 = require("./GraphSelector");
class NotificationStatisticsGraph extends React.PureComponent {
    constructor(props) {
        super(props);
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
    componentDidMount() {
        const { campaignId, fetchReportConnection } = this.props;
        const f = () => {
            fetchReportConnection(campaignId, null, '', null, 12);
            window.removeEventListener('animationend', f);
        };
        window.addEventListener('animationend', f);
    }
    componentUnmount() {
        const { clearReportConnection } = this.props;
        clearReportConnection();
    }
    fetchNextPage() {
        const { campaignId, fetchReportConnection, endCursor, hasNextPage } = this.props;
        if (!hasNextPage) {
            return;
        }
        fetchReportConnection(campaignId, endCursor, null, 12, null);
    }
    fetchPreviousPage() {
        const { campaignId, fetchReportConnection, hasPreviousPage, reportGraphType, startCursor } = this.props;
        if (!hasPreviousPage) {
            return;
        }
        fetchReportConnection(campaignId, null, startCursor, null, 12);
    }
    renderTooltip(props) {
        const { payload } = props;
        const getLegendName = (name) => {
            switch (name) {
                case 'notificationCenter':
                    return 'Notification Center';
                case 'pushDirect':
                    return 'Push Direct';
                case 'pushInfluenced':
                    return 'Push Influenced';
                case 'push':
                    return 'Push';
                default:
                    return '';
            }
        };
        const lineItemStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            minWidth: 228,
        };
        const swatchStyle = {
            height: 16,
            width: 16,
            marginRight: 8,
        };
        return payload && payload.find(({ value }) => value !== 0) ? (React.createElement(src_1.Legend, { style: { width: 'auto' } },
            React.createElement(src_1.Text, { size: "small", text: payload[0].payload.name, textStyle: { color: src_1.steel, marginBottom: 8 } }),
            React.createElement(React.Fragment, null, payload.map(({ color, name, value }, index) => value > 0 && (React.createElement("div", { key: index, style: Object.assign({ marginTop: index > 0 ? 8 : undefined }, lineItemStyle) },
                React.createElement("div", { style: Object.assign(Object.assign({}, swatchStyle), { backgroundColor: color }) }),
                React.createElement(src_1.Text, { size: "small", text: getLegendName(name), textStyle: { flex: '1 0 auto' } }),
                React.createElement(src_1.Text, { size: "small", text: value.toLocaleString(), textStyle: {
                        color: src_1.charcoal,
                        marginLeft: 8,
                    } }))))))) : (React.createElement("div", null));
    }
    render() {
        const { device, formattedReport, hasNextPage, hasPreviousPage, reportGraphType } = this.props;
        return (React.createElement("div", { style: {
                backgroundColor: src_1.aquamarine,
                height: 520,
                width: '100%',
                padding: '152px 32px 24px 0px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginBottom: 16,
                    paddingLeft: device === 'Mobile' ? 24 : 32,
                } },
                React.createElement(GraphSelector_1.default, { device: device }),
                React.createElement("div", null,
                    React.createElement(src_1.ArrowLeftIcon, { fill: "white", onClick: this.fetchPreviousPage }),
                    React.createElement(src_1.ArrowRightIcon, { fill: hasNextPage ? 'white' : 'rgba(255,255,255,0.5)', onClick: this.fetchNextPage, style: {
                            marginLeft: 8,
                        } }))),
            React.createElement(recharts_1.ResponsiveContainer, { width: "100%", height: "95%" },
                React.createElement(recharts_1.BarChart, { width: 736, height: 312, margin: { top: 0, bottom: 0, left: 0, right: 0 }, data: formattedReport },
                    React.createElement("style", { type: "text/css" }, `
                                .recharts-wrapper > svg > g.recharts-cartesian-grid > g > line:nth-child(1) { 
                                    display: none;
                                }
                                .recharts-rectangle {
                                    transform: translateY(-0.5px)
                                }
                            `),
                    React.createElement(recharts_1.CartesianGrid, { vertical: false, strokeDasharray: "1.43 2.87", stroke: "white" }),
                    React.createElement(recharts_1.XAxis, { axisLine: {
                            stroke: 'white',
                            strokeOpacity: 0.25,
                            strokeWidth: 1,
                        }, dataKey: "name", tickFormatter: (tick) => tick.substr(0, 6).toUpperCase(), interval: 2, tick: {
                            stroke: 'none',
                            fill: 'white',
                            fontFamily: 'SourceSansPro-Bold, Source Sans Pro',
                            fontSize: 13,
                            fontWeight: 'bold',
                        }, tickLine: false }),
                    React.createElement(recharts_1.YAxis, { axisLine: { stroke: src_1.aquamarine }, tick: {
                            stroke: 'none',
                            fill: 'white',
                            fontFamily: 'SourceSansPro-Bold, Source Sans Pro',
                            fontSize: 13,
                            fontWeight: 'bold',
                        }, tickLine: false, width: device === 'Mobile' ? 52 : 60 }),
                    reportGraphType === 'opened' && (React.createElement(recharts_1.Bar, { dataKey: "pushDirect", fill: "#77DAE5", minPointSize: 1, stackId: "barchart-stack" })),
                    reportGraphType === 'opened' && (React.createElement(recharts_1.Bar, { dataKey: "pushInfluenced", fill: src_1.foam, minPointSize: 1, stackId: "barchart-stack" })),
                    reportGraphType === 'delivered' && (React.createElement(recharts_1.Bar, { dataKey: "push", fill: src_1.foam, minPointSize: 1, stackId: "barchart-stack" })),
                    React.createElement(recharts_1.Bar, { dataKey: "notificationCenter", fill: "#ACECF4", minPointSize: 1, stackId: "barchart-stack" }),
                    React.createElement(recharts_1.Tooltip, { content: this.renderTooltip, cursor: false, isAnimationActive: false })))));
    }
}
const mapStateToProps = (state) => ({
    formattedReport: reducers_1.getFormattedReport(state),
    hasNextPage: reducers_1.getReportHasNextPage(state),
    hasPreviousPage: reducers_1.getReportHasPreviousPage(state),
    endCursor: reducers_1.getReportEndCursor(state),
    reportGraphType: reducers_1.getReportGraphType(state),
    startCursor: reducers_1.getReportStartCursor(state),
});
const mapDispatchToProps = (dispatch) => ({
    clearReportConnection: () => dispatch(campaigns_1.clearReportConnection()),
    fetchReportConnection: (campaignId, after, before, first, last) => dispatch(actions_1.fetchReportConnection(campaignId, after, before, first, last)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NotificationStatisticsGraph);
